export class GenderIdentityLang {
    public Male: string;
    public Female: string;
    public TransMale: string;
    public TransFemale: string;
    public NonBinary: string;
    public Genderqueer: string;
    public Genderfluid: string;
    public TwoSpirit: string;
    public Agender: string;
    public PrefersNotToSay: string;
    public Other: string;
}


// WEBPACK FOOTER //
// ./src/resources/GenderIdentityLang.ts